// extracted by mini-css-extract-plugin
module.exports = {"WonBoard":"Top37Payouts_WonBoard__10Qhj"};